import { AlertCircle, RefreshCw } from "lucide-react";
import { useEffect, useState } from "react";
import { useRouteError } from "react-router-dom";
import { isChunkLoadError, reloadIfNewBuild, reloadOnceAfterChunkError } from "../lib/build-freshness";
import { Button, LoadingScreen } from "./ui";

/** The root route's error screen: a chunk of a replaced build reloads the page once, anything else asks to refresh. */
export function RouteErrorScreen() {
  const error = useRouteError();
  const chunk = isChunkLoadError(error);
  const [reloading, setReloading] = useState(chunk);
  useEffect(() => {
    if (chunk) {
      if (!reloadOnceAfterChunkError()) setReloading(false);
      return;
    }
    // An old bundle meeting a new server: the new build helps, a retry of the same one does not.
    void reloadIfNewBuild();
  }, [chunk]);
  if (reloading) return <LoadingScreen />;
  return <RouteErrorView />;
}

export function RouteErrorView() {
  return (
    <main className="unavailable-layout">
      <div className="unavailable-card" role="alert">
        <span className="unavailable-card__icon"><AlertCircle aria-hidden="true" size={28} /></span>
        <h1>Страница не открылась</h1>
        <Button icon={RefreshCw} onClick={() => window.location.reload()}>Обновить страницу</Button>
      </div>
    </main>
  );
}
